import { render, staticRenderFns } from "./CSwitcher.vue?vue&type=template&id=11c75f74&scoped=true&"
import script from "./CSwitcher.vue?vue&type=script&lang=ts&"
export * from "./CSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./CSwitcher.vue?vue&type=style&index=0&id=11c75f74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c75f74",
  null
  
)

export default component.exports